import Vue from 'vue'
import VueRouter from 'vue-router'

import About from '@/components/views/About.vue';
import Solutions from '@/components/views/Solutions.vue';
import MapView from '@/components/views/Map.vue';
import References from '@/components/views/References.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: "",
    name: "Landing",
    component: MapView,
    meta: {
      layout: 'AppLayoutMap'
    }    
  }, 
  {
    path: "/map",
    name: "Map",
    component: MapView,
    meta: {
      layout: 'AppLayoutMap'
    }    
  },
  {
    path: "/issues",
    name: "Issues",
    component: About,
    meta: {
      layout: 'AppLayoutAbout'
    }    
  },
  {
    path: "/models",
    name: "Models",
    component: Solutions,
    meta: {
      layout: 'AppLayoutSolutions'
    }    
  },  
  {
    path: "/references",
    name: "References",
    component: References,
    meta: {
      layout: 'AppLayoutReferences'
    }    
  },    
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

export default router
